import { useEffect } from 'react';
import moment from 'moment';
import './Dashboard.css';
import { useAuthContext } from '../../contexts/AuthContext';
import { useParamsContext } from '../../contexts/ParamsContext';
import { useDashboardContext } from './Context';
import DashboardFilters from './DashboardFilters';
import DashboardNav from './DashboardNav';
import ExecutiveDashboard from './ExecutiveDashboard';
import ClientsDashboard from './ClientsDashboard';
import TeamDashboard from './TeamDashboard';
import StockDashboard from './StockDashboard';
import SalesDashboard from './SalesDashboard';
import { StaticDashboard } from './StaticDashboard';
import { dashboardItems } from './DashboardNav';
import { usePlanAccess } from '../../plans/usePlanAccess';

export const Dashboards = () => {
    const { user } = useAuthContext();
    const { action, clear } = useParamsContext();
    const { atendenteId, setAtendenteId, endAt } = useDashboardContext();
    const { hasFeature } = usePlanAccess();

    useEffect(() => {
        if (action === 'print') {
            clear();
        }
    }, [action, clear]);

    useEffect(() => {
        if (!user?.uid) return;
        if (!atendenteId && !(user?.admin || user?.root)) {
            setAtendenteId(user.uid);
        }
    }, [atendenteId, setAtendenteId, user?.admin, user?.root, user?.uid]);

    const availableItems = dashboardItems.filter((item) => hasFeature(item.feature));
    const current = availableItems.some((item) => item.key === action)
        ? action
        : availableItems[0]?.key || 'basico';

    return (
        <div className="sf-dashboard-shell flex flex-col gap-6 pb-6">
            <DashboardNav />
            <DashboardFilters />
            {current === 'basico' && (
                <p className="sf-dashboard-context">
                    Resumo de {moment(endAt).format('MMMM [de] YYYY')}. As visões de dia e semana usam {moment(endAt).format('DD/MM/YYYY')} como referência.
                </p>
            )}

            {current === 'basico' && <StaticDashboard />}
            {current === 'executivo' && <ExecutiveDashboard />}
            {current === 'vendas' && <SalesDashboard />}
            {current === 'clientes' && <ClientsDashboard />}
            {current === 'time' && <TeamDashboard />}
            {current === 'estoque' && <StockDashboard />}
        </div>
    );
};
